package team.platforma.multiplatform_material_extension.ui.buttons.utils

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import kotlinx.browser.window

@Composable
actual fun observeKeyBoardFab(int: (Int) -> Unit) {
    val visualViewport = js("window.visualViewport")
    if (visualViewport != undefined) {
        visualViewport.addEventListener("resize") {
            val currentHeight = js("window.innerHeight").unsafeCast<Int>()
            val viewportHeight = js("visualViewport.height").unsafeCast<Double>().toInt()
            val keyboardHeight = (currentHeight - viewportHeight).coerceAtLeast(0)
            int(keyboardHeight + 16)
        }
    } else {
        // Fallback для браузеров без visualViewport
        val initialHeight = js("window.innerHeight").unsafeCast<Int>()
        window.addEventListener("resize", {
            val currentHeight = js("window.innerHeight").unsafeCast<Int>()
            val keyboardHeight = (initialHeight - currentHeight).coerceAtLeast(0)
            int(keyboardHeight + 16)
        })
    }
}